import { __rest as r } from "tslib";
import * as e from "react";
import { Text as s } from "../Text/Text.js";
import { ComponentClassNames as a } from "../shared/constants.js";
const o = o => {
  var {
      errorMessage: t,
      hasError: m
    } = o,
    i = r(o, ["errorMessage", "hasError"]);
  return m && t ? e.createElement(s, Object.assign({
    className: a.FieldErrorMessage
  }, i), t) : null;
};
o.displayName = "FieldErrorMessage";
export { o as FieldErrorMessage };